import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { "data-cy": "stockProduct-bom" }
const _hoisted_2 = { class: "align-center" }
const _hoisted_3 = { class: "align-center" }
const _hoisted_4 = { class: "text-center pl-3 pb-2" }
const _hoisted_5 = { class: "mx-2" }
const _hoisted_6 = { class: "align-center" }
const _hoisted_7 = { class: "align-center" }
const _hoisted_8 = { class: "text-center pl-3 pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_textarea_filled = _resolveComponent("v-textarea-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "py-1"
  }, {
    default: _withCtx(() => [
      (_ctx.saveable)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12",
            class: "pl-2 py-0 mb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                modelValue: _ctx.saveProduct,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.saveProduct) = $event)),
                label: "Enregistrer le produit",
                class: "py-0 mb-0",
                "data-cy": "createInvoiceProduct-saveProduct"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_col, {
        cols: "12",
        class: "pb-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FreeTag, {
            invoiceProduct: _ctx.product,
            companyTags: _ctx.allCompanyTags,
            company: _ctx.selectedCompany,
            createIfMissing: true,
            multiple: false,
            onOnTagsChanged: _ctx.onTagsChanged
          }, null, 8, ["invoiceProduct", "companyTags", "company", "onOnTagsChanged"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "7",
        class: "pr-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field_filled, {
            outlined: "",
            modelValue: _ctx.product.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.title) = $event)),
            label: "Nom du produit",
            dense: "",
            "data-cy": "CreateInvoiceProduct-nom"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "5",
        class: "pl-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field_filled, {
            modelValue: _ctx.product.reference,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.reference) = $event)),
            label: "Référence du produit",
            "data-cy": "CreateInvoiceProduct-reference",
            "error-messages": _ctx.productReferenceRules
          }, null, 8, ["modelValue", "error-messages"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        class: "d-flex flex-row mt-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeTab) = $event)),
            direction: "vertical",
            "center-active": "",
            style: {"background-color":"transparent !important","border-radius":"16px","overflow":"hidden"},
            id: "Stock"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tab, {
                value: "Description",
                "data-cy": "invoices-description-tab"
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createTextVNode(" Description ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_tab, {
                value: "Stock",
                disabled: !_ctx.enableStock,
                "data-cy": "invoices-stock-tab"
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createTextVNode(" Stock ")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_tabs_window, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.activeTab) = $event)),
            style: {"background-color":"transparent !important"},
            class: "flex-grow-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs_window_item, { value: "Description" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "py-1 w-100"
                  }, {
                    default: _withCtx(() => [
                      (
                                !_ctx.enableStock && _ctx.salesAccountableAccounts.length > 1 && !_ctx.isDiscount
                            )
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select_filled, {
                                modelValue: _ctx.accountableAccountSelected,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.accountableAccountSelected) = $event)),
                                items: _ctx.salesAccountableAccounts,
                                label: "Compte comptable du produit",
                                "item-title": "description",
                                "item-value": "id",
                                "data-cy": "createInvoiceProduct-accountableAccount"
                              }, null, 8, ["modelValue", "items"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.vatSubject)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "12",
                            class: "pt-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select_filled, {
                                modelValue: _ctx.product.vatRate,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.product.vatRate) = $event)),
                                items: _ctx.vatList,
                                "menu-props": { auto: true },
                                label: "Taux de TVA",
                                "data-cy": "createInvoiceProduct-vatRate",
                                "hide-details": ""
                              }, null, 8, ["modelValue", "items"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_text_field_filled, {
                            class: "pt-2",
                            outlined: "",
                            suffix: _ctx.amountType === 'percentage' ? '%' : '€',
                            label: 
                                    _ctx.amountType === 'percentage'
                                        ? 'Pourcentage de la remise'
                                        : 'Prix unitaire'
                                ,
                            dense: "",
                            "data-cy": "createInvoiceProduct-unitPrice-radio",
                            "hide-details": "",
                            modelValue: _ctx.amount,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.amount) = $event))
                          }, null, 8, ["suffix", "label", "modelValue"]),
                          _createVNode(_component_v_textarea_filled, {
                            class: "pt-2",
                            "auto-grow": "",
                            label: "Description",
                            modelValue: _ctx.product.description,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.product.description) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (!_ctx.saveable && !_ctx.actions)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 2,
                            cols: "12",
                            class: "d-flex justify-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                elevation: "0",
                                size: "small",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.save())),
                                disabled: _ctx.disabledSave(),
                                loading: _ctx.saveLoading,
                                "data-cy": "createInvoiceProduct-upsert"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(!_ctx.id ? "Créer le produit" : "Modifier le produit"), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "loading"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_tabs_window_item, { value: "Stock" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window, {
                    modelValue: _ctx.wizardStep,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.wizardStep) = $event)),
                    class: "elevation-0",
                    style: {"background":"transparent"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window_item, { value: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "py-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "pb-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select_filled, {
                                    modelValue: _ctx.product.type,
                                    "onUpdate:modelValue": [
                                      _cache[9] || (_cache[9] = ($event: any) => ((_ctx.product.type) = $event)),
                                      _cache[10] || (_cache[10] = ($event: any) => (_ctx.accountableAccountSelected = ''))
                                    ],
                                    items: _ctx.stockProductTypes,
                                    label: "Type",
                                    "item-title": "description",
                                    "item-value": "type",
                                    "data-cy": "createStockProduct-accountableAccount",
                                    "hide-details": ""
                                  }, null, 8, ["modelValue", "items"])
                                ]),
                                _: 1
                              }),
                              (_ctx.product.type === 'EXPENSE')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "12",
                                    class: "pb-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.accountableAccountSelected,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.accountableAccountSelected) = $event)),
                                        items: _ctx.expenseAccountableAccounts,
                                        label: "Compte de charge",
                                        "item-title": "description",
                                        "item-value": "id",
                                        "data-cy": "createStockProduct-accountableAccount",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue", "items"])
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_col, {
                                    key: 1,
                                    cols: "10",
                                    class: "pb-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.accountableAccountSelected,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.accountableAccountSelected) = $event)),
                                        items: _ctx.salesAccountableAccounts,
                                        label: "Compte de variation de stocks",
                                        "item-title": "description",
                                        "item-value": "id",
                                        readonly: _ctx.product.type === 'EXPENSE',
                                        "data-cy": "createStockProduct-inventoryAccountableAccount",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue", "items", "readonly"])
                                    ]),
                                    _: 1
                                  })),
                              (_ctx.product.type === 'PRODUCT')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 2,
                                    cols: "2",
                                    class: "pb-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        elevation: "0",
                                        class: "ml-4",
                                        color: "primary",
                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.wizardStep = 2))
                                      }, {
                                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                                          _createTextVNode(" B O M ")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.product.type === 'EXPENSE')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 3,
                                    cols: "12",
                                    class: "pb-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: _ctx.selectedThirdPartyCompany.name,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedThirdPartyCompany.name) = $event)),
                                        readonly: "",
                                        label: "Fournisseur",
                                        "data-cy": "createStockProduct-thirdPartyCompany",
                                        "hide-details": "",
                                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.wizardStep++))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subproductLines, (subproduct, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  _createVNode(_component_v_col, {
                                    cols: "3",
                                    class: "pt-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: subproduct.quantityType,
                                        "onUpdate:modelValue": ($event: any) => ((subproduct.quantityType) = $event),
                                        items: _ctx.quantityTypes,
                                        "item-title": "text",
                                        "item-value": "value",
                                        "menu-props": { auto: true },
                                        label: "Grandeur",
                                        "data-cy": "createInvoiceProduct-quantityType",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "pt-1 pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_text_field_filled, {
                                        outlined: "",
                                        label: _ctx.getUnitOfMeasureLabel(subproduct.quantityType),
                                        "content-class": "oss-dark pl-2",
                                        dense: "",
                                        "data-cy": "createInvoiceProduct-unitOfMesure",
                                        "hide-details": "",
                                        modelValue: subproduct.unitQuantity,
                                        "onUpdate:modelValue": ($event: any) => ((subproduct.unitQuantity) = $event)
                                      }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "pt-1 pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        "model-value": _ctx.getSymbolData(subproduct).text,
                                        label: "Affichage",
                                        "data-cy": "createInvoiceProduct-display",
                                        readonly: "",
                                        "hide-details": ""
                                      }, null, 8, ["model-value"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    "pt-1": "",
                                    class: "pt-1 pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field_filled, {
                                        modelValue: subproduct.quantityName,
                                        "onUpdate:modelValue": ($event: any) => ((subproduct.quantityName) = $event),
                                        label: "Nom",
                                        "data-cy": "createInvoiceProduct-quantityName",
                                        "hide-details": "auto"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "1",
                                    class: "align-content-center align-center justify-center pt-1 px-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "d-flex flex-row justify-center align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "5",
                                            class: "my-auto"
                                          }, {
                                            default: _withCtx(() => [
                                              (_ctx.subproductEnabled(index, true))
                                                ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                    key: 0,
                                                    icon: "$add",
                                                    density: "comfortable",
                                                    elevation: "0",
                                                    color: "primary",
                                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (
                                                        _ctx.subproductLines.push({
                                                            ..._ctx.defaultSubproduct,
                                                        })
                                                    ))
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, { cols: "5" }, {
                                            default: _withCtx(() => [
                                              (_ctx.subproductEnabled(index, false))
                                                ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                    key: 0,
                                                    density: "comfortable",
                                                    onClick: ($event: any) => (_ctx.deleteSubproduct(index))
                                                  }, null, 8, ["onClick"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 64))
                              }), 256))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "1" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn_back, {
                                    size: "small",
                                    onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.wizardStep = 0), ["stop"]))
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CompaniesTable, {
                            parentCompanyId: _ctx.companyId,
                            showGenericCompany: _ctx.product.type === 'EXPENSE',
                            showCustomerCompanies: _ctx.product.type === 'PRODUCT',
                            showSupplierCompanies: _ctx.product.type === 'EXPENSE',
                            showExistingCompanies: false,
                            onSelectCompany: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setThirdParty($event)))
                          }, null, 8, ["parentCompanyId", "showGenericCompany", "showCustomerCompanies", "showSupplierCompanies"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: 2 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn_back, {
                                size: "small",
                                onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.wizardStep = 0), ["stop"]))
                              }),
                              _createVNode(_component_v_data_table, {
                                headers: _ctx.bomHeaders,
                                items: _ctx.bomLines,
                                class: "table strong-border",
                                "fixed-header": "",
                                "max-height": "60vh",
                                "multi-sort": false,
                                "no-data-text": 'Aucun produit ajouté',
                                "hide-default-footer": ""
                              }, {
                                item: _withCtx(({ item, index }) => [
                                  _createElementVNode("tr", _hoisted_1, [
                                    _createElementVNode("td", _hoisted_2, [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: item.tagId,
                                        "onUpdate:modelValue": ($event: any) => ((item.tagId) = $event),
                                        items: _ctx.productTags,
                                        "item-title": "name",
                                        "item-value": "id",
                                        "hide-details": true,
                                        class: "v-select-font-size",
                                        "data-cy": "bom-product"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                    ]),
                                    _createElementVNode("td", _hoisted_3, [
                                      _createVNode(_component_oss_text_field_filled, {
                                        dense: "",
                                        filled: "",
                                        "hide-details": true,
                                        outlined: "",
                                        class: "ml-2 righted-input",
                                        modelValue: item.quantity,
                                        "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("td", _hoisted_4, [
                                      _createVNode(_component_v_btn_trash, {
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.bomLines.splice(index, 1))
                                      }, null, 8, ["onClick"])
                                    ])
                                  ])
                                ]),
                                "body.append": _withCtx(() => [
                                  _createElementVNode("tr", _hoisted_5, [
                                    _createElementVNode("td", _hoisted_6, [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.newItem.tagId,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newItem.tagId) = $event)),
                                        items: _ctx.productTags,
                                        "item-title": "name",
                                        "item-value": "id",
                                        "hide-details": true,
                                        class: "v-select-font-size",
                                        "data-cy": "bom-product"
                                      }, null, 8, ["modelValue", "items"])
                                    ]),
                                    _createElementVNode("td", _hoisted_7, [
                                      _createVNode(_component_oss_text_field_filled, {
                                        dense: "",
                                        filled: "",
                                        "hide-details": true,
                                        outlined: "",
                                        class: "ml-2 righted-input",
                                        modelValue: _ctx.newItem.quantity,
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newItem.quantity) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("td", _hoisted_8, [
                                      _createVNode(_component_v_btn_icon, {
                                        icon: "$add",
                                        size: "small",
                                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.addItem())),
                                        disabled: _ctx.disabledAdd,
                                        elevation: "0",
                                        color: "secondary"
                                      }, null, 8, ["disabled"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["headers", "items"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}